
import Component from '../../../assets/scripts/modules/component'
import { setCookie } from '../../../assets/scripts/utilities/simple-cookie.js'

export default class CookiePreferencesSaveComponent extends Component {
  init () {
    this.button = this.element.querySelector('.button.button--primary')

    if (!this.button) {
      return
    }

    this.button.addEventListener('click', () => requestAnimationFrame(() => this.saveCookie()))
  }

  setCookie (name, value) {
    setCookie(name + '-enabled', value)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: name + '-enabled', value })
  }

  saveCookie () {
    document.querySelectorAll('.cookie-preferences .toggle-field input').forEach(input => {
      if (input.name) {
        this.setCookie(input.name, input.checked)
      }
    })
    this.button.querySelector('span').textContent = 'Opgeslagen'
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.cookie-preferences-save').forEach(element => {
  element.instance = element.instance || new CookiePreferencesSaveComponent(element)
}))
